
const pxToInteger = (value) => parseInt(value, 10);

export {
  pxToInteger
};
